import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { createRepository } from '@/repositories/GenericRepository';
import { Blueprint, BlueprintPayload, TaskableType } from '@/types/blueprint';
import { QueryParams } from '@/types/query';
import ajax from '@/utils/ajax';

const basePath = '/api/work/blueprints';

export const blueprintRepository = createRepository<Blueprint, BlueprintPayload>(basePath);

const BlueprintRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async list(params: QueryParams = {}) {
      return blueprintRepository.list({ host, params });
    },

    async get(id: string) {
      return blueprintRepository.get({ host, id });
    },

    async create(data: Partial<BlueprintPayload>) {
      return blueprintRepository.create({ host, data });
    },

    async update(id: string, data: Partial<BlueprintPayload>) {
      return blueprintRepository.update({ host, id, data });
    },

    async delete(id: string) {
      return blueprintRepository.delete({ host, id });
    },

    async listTaskableTypes(): Promise<TaskableType[]> {
      const response = await ajax.get({ url: `${host}${basePath}/taskable_types/` });
      return response.data as TaskableType[];
    }
  };
};

export default BlueprintRepository;
